import React from 'react';
import { DatePicker, Input, Row, Col, Space, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import dayjs from 'dayjs';
import { ExpenseJournalStatus } from 'constants/Data';

interface Props {
	year: number | null;
	onYearChange: (year: number | null) => void;
	onStatusChange: (status: 'All' | ExpenseJournalStatus) => void;
	search: string;
	onSearchChange: (search: string) => void;
	status: 'All' | ExpenseJournalStatus;
}

const ExpenseJournalSearchAndFilter: React.FC<Props> = ({
	year,
	onYearChange,
	onStatusChange,
	search,
	onSearchChange,
	status,
}) => {

	return (
		<div className={styles['search-filter']}>
			<div className={styles['search-filter__wrapper']}>
				<Row justify="space-between" align="middle" gutter={[16, 16]}>
					<Col span={12}>
						<Space>
							<Input
								className={styles['search-filter__search']}
								placeholder="Search here..."
								style={{
									fontSize: '12px',
									minHeight: '40px',
									width: 160,
									minWidth: 250,
								}}
								size="large"
								suffix={<SearchOutlined />}
								value={search}
								onChange={(e) => onSearchChange(e.target.value)}
							/>
							<DatePicker
								picker="year"
								size="large"
								value={year ? dayjs(String(year), 'YYYY') as any : null}
								format="YYYY"
								onChange={(d) =>
									onYearChange(d ? (d as any).year() : null)
								}
								style={{ minWidth: 250, height: 40, fontSize: '12px' }}
							/>
							<Select
								value={status}
								onChange={(v) => onStatusChange(v as any)}
								style={{
									width: 160,
									minWidth: 250,
									height: 40,
									fontSize: '12px',
								}}
								options={[
									{ value: '', label: 'Select Status' },
									{ value: ExpenseJournalStatus.PUBLISHED, label: 'Published' },
									{ value: ExpenseJournalStatus.DRAFT, label: 'Draft' },
								]}
							/>
						</Space>
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default ExpenseJournalSearchAndFilter;
